import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import Swal from 'sweetalert2'
import Rightcontainer from '../Components/Rightcontainer'
import '../css/Loader.css'
import findGif from '../css/loading.gif'
import { apiRequest } from '../store/allApi'
import socket from '../Components/socket'
function Return({ walletUpdate }) {


  // BASE URL

  // const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  // const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  // const nodeMode = process.env.NODE_ENV;
  // if (nodeMode === "development") {

  //   var baseUrl = beckendLocalApiUrl;
  // } else {
  //   baseUrl = beckendLiveApiUrl;
  // }
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  // +++++++++++++++++++++++++++++ 

  const history = useHistory()
  var url_string = window.location.href //window.location.href
  var url = new URL(url_string)

  var client_txn_id = url.searchParams.get('client_txn_id')
  var txn_id = url.searchParams.get('txn_id')
  if (client_txn_id && txn_id) {
    var order_id = client_txn_id
    var order_token = txn_id
  } else {
    var order_id = url.searchParams.get('order_id')
    var order_token = url.searchParams.get('order_token')
  }

  const [status, setStatus] = useState()

  const refreshWallet = () => {
    if (typeof walletUpdate === 'function') walletUpdate()
    socket.emit('getprofile')
  }

  const showDepositResult = (paid, message) => {
    refreshWallet()
    history.push('/')
    setTimeout(() => {
      Swal.fire({
        title: message,
        icon: paid ? 'success' : 'error',
        confirmButtonText: 'OK'
      })
    }, 300)
  }

  const depositupipay = async () => {
    let access_token = localStorage.getItem('token')
    access_token = localStorage.getItem('token')
    if (!access_token) {
      history.push('/login')
      return
    }
    const headers = {
      Authorization: `Bearer ${access_token}`
    }

    const txnID = order_token || order_id
    if (!txnID) {
      showDepositResult(false, 'Deposit reference missing')
      return
    }

    try {
      const res = await apiRequest(`checkout/deposite/txn`, "POST", { txnID }, headers)
      setStatus(res.data.txnStatus)
      const paid = res.data.txnStatus === 'PAID' || res.data.txnStatus === 'SUCCESS'
      showDepositResult(paid, paid ? 'Deposit submitted successfully' : (res.data.msg || 'Transaction failed'))
    } catch (e) {
      if (e.response?.status == 401) {
        localStorage.removeItem('token')
        window.location.reload()
        history.push('/login')
        return
      }
      showDepositResult(false, e.response?.data?.msg || 'Could not confirm this deposit')
    }
  }
  useEffect(() => {
    depositupipay();
  }, [])

  return (
    <>
      <div
        className='leftContainer'
        style={{
          position: 'relative',
          minHeight: '100vh',
          height: '100%',
          paddingTop: '60px'
        }}
      >
        <div className='loaderReturn'>
          <img src={findGif} style={{ width: '15px', height: '15px' }} />
        </div>
      </div>
      <div className='rightContainer'>
        <Rightcontainer />
      </div>
    </>
  )
}

export default Return
